/// <reference path="../modules/app.module.ts" />

module App {
    export interface IValidateEmail extends ng.IDirective {
        
    }
    export class ValidateEmail implements IValidateEmail {
        static directiveId: string = "validateEmail";

        restrict: string = "A";

        require = 'ngModel';

        constructor() {

        }

        link = (scope, elm, attrs, ctrl) => {
            // only apply the validator if ngModel is present and Angular has added the email validator
            if (ctrl && ctrl.$validators.email) {

                // this will overwrite the default Angular email validator
                ctrl.$validators.email = (modelValue) => {
                    return ctrl.$isEmpty(modelValue) || Constants.regexExp.email.test(modelValue);
                };
            } else {
                ctrl.$parsers.unshift((value) => {
                    var valid = ctrl.$isEmpty(value) || Constants.regexExp.email.test(value);
                    ctrl.$setValidity('email', valid);
                    return valid ? value : undefined;
                });
            }
        }
    }

    app.directive(ValidateEmail.directiveId, [() => new ValidateEmail() ]);
}